import { getMonth } from './getMonth'

export const getDate = (date: string) => {
  const currentDate = new Date().toISOString()

  const currentDateObj = new Date(currentDate)
  const dateObj = new Date(date)

  dateObj.setHours(dateObj.getHours() - 2)

  const diffInMc = currentDateObj.getTime() - dateObj.getTime()
  const diffInMinutes = diffInMc / (1000 * 60)
  const diffInHours = diffInMinutes / 60

  if (diffInHours < 24 && diffInHours >= 1) {
    return diffInHours.toFixed(0) + ' год'
  }

  if (diffInMinutes < 60) {
    return diffInMinutes.toFixed(0) + ' хв'
  }

  const created = date.split('T')[0].split('-')
  return created[2] + ' ' + getMonth(created[1])
}
